import React from 'react';
import { Button } from '../components/ui/Button';
import { GlobeIcon, TrendingUpIcon, UsersIcon, AwardIcon } from 'lucide-react';
export function AboutPage() {
  return <div className="w-full" data-id="element-123">
      {/* Hero Section */}
      <section className="bg-black text-white py-20" data-id="element-124">
        <div className="container mx-auto px-4" data-id="element-125">
          <div className="max-w-3xl" data-id="element-126">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-127">
              About Rawfounders
            </h1>
            <p className="text-xl text-gray-300" data-id="element-128">
              A global corporate group building innovative businesses across
              multiple industries.
            </p>
          </div>
        </div>
      </section>
      {/* Founder Section */}
      <section className="py-16 md:py-24 bg-white" data-id="element-129">
        <div className="container mx-auto px-4" data-id="element-130">
          <div className="max-w-5xl mx-auto" data-id="element-131">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-132">
              <div className="order-2 md:order-1" data-id="element-133">
                <h2 className="text-3xl font-bold text-black mb-6" data-id="element-134">
                  Our Founder
                </h2>
                <h3 className="text-xl font-semibold text-black mb-2" data-id="element-135">
                  Ramzad Kumble
                </h3>
                <p className="text-amber-600 font-medium mb-4" data-id="element-136">
                  Founder & Chief Executive Officer
                </p>
                <p className="text-lg text-gray-600 mb-6" data-id="element-137">
                  Ramzad Kumble is a visionary entrepreneur with extensive
                  experience in real estate, technology, and AI solutions. His
                  innovative approach to business has led to the creation of
                  Rawfounders, a corporate umbrella brand with multiple
                  verticals spanning various industries.
                </p>
                <p className="text-lg text-gray-600 mb-6" data-id="element-138">
                  With a keen eye for emerging market opportunities and a
                  passion for technology-driven solutions, Ramzad has
                  successfully launched and scaled multiple ventures under the
                  Rawfounders umbrella, including Rawfound Properties,
                  Shoplinky, and Agentter.ai.
                </p>
                <p className="text-lg text-gray-600" data-id="element-139">
                  Based in Dubai, UAE, Ramzad continues to drive the strategic
                  vision for Rawfounders, focusing on innovation, sustainable
                  growth, and creating value across all business verticals.
                </p>
              </div>
              <div className="order-1 md:order-2" data-id="element-140">
                <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-141">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pqYYcXEHrpEEUAHD6jA7LS/20ec474c-f476-4de2-905c-10332593b02a_%281%29.jpg" alt="Ramzad Kumble - Founder of Rawfounders" className="w-full h-auto" data-id="element-142" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Mission & Vision */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-143">
        <div className="container mx-auto px-4" data-id="element-144">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 max-w-5xl mx-auto" data-id="element-145">
            <div data-id="element-146">
              <h2 className="text-3xl font-bold text-black mb-6" data-id="element-147">
                Our Mission
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-148">
                At Rawfounders, our mission is to identify opportunities, build
                innovative solutions, and create sustainable businesses that
                deliver exceptional value to customers, partners, and society.
              </p>
              <p className="text-lg text-gray-600" data-id="element-149">
                We combine entrepreneurial vision with corporate expertise to
                build, acquire, and scale businesses that have the potential to
                transform industries and create lasting impact.
              </p>
            </div>
            <div data-id="element-150">
              <h2 className="text-3xl font-bold text-black mb-6" data-id="element-151">Our Vision</h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-152">
                To be a global leader in building innovative businesses that
                transform industries and create lasting value across
                hospitality, commerce, and technology sectors.
              </p>
              <p className="text-lg text-gray-600" data-id="element-153">
                We envision a future where our ventures lead their respective
                markets, driving innovation and setting new standards for
                excellence and customer satisfaction.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Our Values */}
      <section className="py-16 md:py-24 bg-white" data-id="element-154">
        <div className="container mx-auto px-4" data-id="element-155">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-156">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-157">
              Our Core Values
            </h2>
            <p className="text-lg text-gray-600" data-id="element-158">
              These principles guide our decisions, shape our culture, and
              define how we operate across all our ventures.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto" data-id="element-159">
            <div className="bg-gray-50 p-8 rounded-lg shadow-sm text-center" data-id="element-160">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-161">
                <AwardIcon className="h-8 w-8 text-black" data-id="element-162" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-163">
                Excellence
              </h3>
              <p className="text-gray-600" data-id="element-164">
                We pursue excellence in everything we do, setting high standards
                and continuously improving.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg shadow-sm text-center" data-id="element-165">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-166">
                <TrendingUpIcon className="h-8 w-8 text-black" data-id="element-167" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-168">
                Innovation
              </h3>
              <p className="text-gray-600" data-id="element-169">
                We embrace innovation and creative thinking to solve problems
                and create new opportunities.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg shadow-sm text-center" data-id="element-170">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-171">
                <UsersIcon className="h-8 w-8 text-black" data-id="element-172" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-173">
                Integrity
              </h3>
              <p className="text-gray-600" data-id="element-174">
                We act with honesty, transparency, and ethical conduct in all
                our business dealings.
              </p>
            </div>
            <div className="bg-gray-50 p-8 rounded-lg shadow-sm text-center" data-id="element-175">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-176">
                <GlobeIcon className="h-8 w-8 text-black" data-id="element-177" />
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-178">
                Global Mindset
              </h3>
              <p className="text-gray-600" data-id="element-179">
                We think and operate globally, embracing diversity and adapting
                to local needs.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Our Approach */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-180">
        <div className="container mx-auto px-4" data-id="element-181">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-182">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-183">
              Our Approach
            </h2>
            <p className="text-lg text-gray-600" data-id="element-184">
              How we build and grow innovative businesses across industries.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-185">
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-186">
              <div className="w-12 h-12 bg-black text-white rounded-full flex items-center justify-center mb-6 text-xl font-bold" data-id="element-187">
                1
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-188">
                Identify Opportunities
              </h3>
              <p className="text-gray-600" data-id="element-189">
                We continuously research markets to identify gaps and
                opportunities where innovation can create value.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-190">
              <div className="w-12 h-12 bg-black text-white rounded-full flex items-center justify-center mb-6 text-xl font-bold" data-id="element-191">
                2
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-192">
                Build Solutions
              </h3>
              <p className="text-gray-600" data-id="element-193">
                We develop innovative, technology-driven solutions that address
                real market needs and deliver exceptional value.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-194">
              <div className="w-12 h-12 bg-black text-white rounded-full flex items-center justify-center mb-6 text-xl font-bold" data-id="element-195">
                3
              </div>
              <h3 className="text-xl font-semibold text-black mb-3" data-id="element-196">
                Scale Sustainably
              </h3>
              <p className="text-gray-600" data-id="element-197">
                We focus on sustainable growth, building businesses that create
                long-term value for all stakeholders.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Global Presence */}
      <section className="py-16 md:py-24 bg-white" data-id="element-198">
        <div className="container mx-auto px-4" data-id="element-199">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-200">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6" data-id="element-201">
              Global Presence
            </h2>
            <p className="text-lg text-gray-600" data-id="element-202">
              With our headquarters in Dubai and strategic offices in key global
              markets, Rawfounders is positioned to serve clients worldwide.
            </p>
          </div>
          <div className="max-w-5xl mx-auto" data-id="element-203">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-204">
              <div className="bg-gray-50 rounded-lg shadow-sm overflow-hidden" data-id="element-205">
                <div className="h-64 bg-gray-200" data-id="element-206">
                  <img src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Dubai Skyline" className="w-full h-full object-cover" data-id="element-207" />
                </div>
                <div className="p-6" data-id="element-208">
                  <h3 className="text-xl font-semibold text-black mb-2" data-id="element-209">
                    Dubai
                  </h3>
                  <p className="text-gray-600 mb-2 font-medium" data-id="element-210">Headquarters</p>
                  <p className="text-gray-600" data-id="element-211">
                    Lincoln Park, Barsha South, Dubai, UAE
                  </p>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg shadow-sm overflow-hidden" data-id="element-212">
                <div className="h-64 bg-gray-200" data-id="element-213">
                  <img src="https://images.unsplash.com/photo-1596176530529-78163a4f7af2?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Bangalore City" className="w-full h-full object-cover" data-id="element-214" />
                </div>
                <div className="p-6" data-id="element-215">
                  <h3 className="text-xl font-semibold text-black mb-2" data-id="element-216">
                    Bangalore
                  </h3>
                  <p className="text-gray-600 mb-2 font-medium" data-id="element-217">Asia Office</p>
                  <p className="text-gray-600" data-id="element-218">
                    Technology Hub, Bangalore, India
                  </p>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg shadow-sm overflow-hidden" data-id="element-219">
                <div className="h-64 bg-gray-200" data-id="element-220">
                  <img src="https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="London City" className="w-full h-full object-cover" data-id="element-221" />
                </div>
                <div className="p-6" data-id="element-222">
                  <h3 className="text-xl font-semibold text-black mb-2" data-id="element-223">
                    London
                  </h3>
                  <p className="text-gray-600 mb-2 font-medium" data-id="element-224">
                    Europe Office
                  </p>
                  <p className="text-gray-600" data-id="element-225">
                    Financial District, London, UK
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-black text-white" data-id="element-226">
        <div className="container mx-auto px-4" data-id="element-227">
          <div className="max-w-4xl mx-auto text-center" data-id="element-228">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-229">
              Join Our Journey
            </h2>
            <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-230">
              Whether you're interested in our services, seeking partnership
              opportunities, or exploring investment possibilities, we'd love to
              hear from you.
            </p>
            <Button href="/contact" size="lg" data-id="element-231">
              Contact Us
            </Button>
          </div>
        </div>
      </section>
    </div>;
}